import React from 'react';
import type { PtDirectoryPatient } from '../../../patients-list/types';
import { ptFormatMoney, ptRollupHealth } from '../../../patients-list/utils';
import { Button } from '../../Button/Button';

export interface PatientsSummaryBarProps {
  patients: PtDirectoryPatient[];
}

function SumPill({
  label,
  value,
  color,
  bg,
}: {
  label: string;
  value: string | number;
  color: string;
  bg: string;
}) {
  return (
    <div className="pt-sum-pill" style={{ background: bg }}>
      <span
        className="font-[var(--font-display)] text-lg font-bold leading-none tracking-[-0.02em]"
        style={{ color }}
      >
        {value}
      </span>
      <span className="text-xs text-[var(--ink-3)]">{label}</span>
    </div>
  );
}

export function PatientsSummaryBar({ patients }: PatientsSummaryBarProps) {
  const total = patients.length;
  const unconfirmed = patients.filter((p) => !p.confirmed).length;
  const noInsurance = patients.filter((p) => !p.insurance).length;
  const critical = patients.filter((p) => ptRollupHealth(p) === 'critical').length;
  const newPatients = patients.filter((p) => p.newPatient).length;
  const inTriage = patients.filter((p) => p.triageItems > 0).length;
  const production = patients.reduce((s, p) => s + (p.todayValue || 0), 0);

  return (
    <div className="pt-summary">
      <SumPill label="patients" value={total} color="var(--ink-0)" bg="var(--cream-0)" />
      <SumPill
        label="critical"
        value={critical}
        color="var(--terracotta)"
        bg="var(--terracotta-tint)"
      />
      <SumPill label="unconfirmed" value={unconfirmed} color="#9A6B1E" bg="var(--gold-tint)" />
      <SumPill label="no insurance" value={noInsurance} color="#9A6B1E" bg="var(--gold-tint)" />
      <SumPill label="in triage" value={inTriage} color="#9A6B1E" bg="var(--gold-tint)" />
      <SumPill label="new" value={newPatients} color="var(--ai-3)" bg="var(--ai-tint)" />
      <SumPill
        label="production"
        value={ptFormatMoney(production)}
        color="var(--success)"
        bg="var(--success-tint)"
      />
      <div className="ml-auto flex items-center gap-2">
        <Button variant="secondary" size="sm" iconLeft="filter">
          Filter
        </Button>
      </div>
    </div>
  );
}
